import script from "./SYS50_001INS.vue?vue&type=script&setup=true&lang=js"
export * from "./SYS50_001INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__